import InvoiceSummaryForPartnerListItem from "Models/InvoiceSummaryForPartnerListItem";
import IInvoiceSummaryApiAdapter from "Adapters/IInvoiceSummaryApiAdapter";
import ProtectedApiAdapterBase from "Adapters/ProtectedApiAdapterBase";
import { mapInvoiceSummaryDetailsDtoToDomainModel, mapInvoiceSummaryForPartnerListItemDtoToDomainModel } from "Adapters/Mapping/Map";
import { IGetInvoiceSummaryDetailsResponse, IGetInvoiceSummaryForPartnerListResponse, IGetInvoiceSummaryListRequest } from "Adapters/Api/Api.g";
import InvoiceSummaryDetails from "Models/InvoiceSummaryDetails";
import Ordering from "Adapters/QueryHelpers/Ordering";
import Paging from "Adapters/QueryHelpers/Paging";

class AdminInvoiceSummaryApiAdapter extends ProtectedApiAdapterBase implements IInvoiceSummaryApiAdapter {

    private readonly mainRoute = "api/web/admin/Partner";

    public getListAsync(paging: Paging, ordering: Ordering, filter: any, partnerId: number): Promise<{ totalCount: number, invoiceSummaries: InvoiceSummaryForPartnerListItem[] }> {
        const request: IGetInvoiceSummaryListRequest = {
            pageNumber: paging.pageNumber,
            pageSize: paging.pageSize,
            orderBy: ordering.orderBy,
            orderAsc: ordering.orderAsc,
            ...filter
        }
        return this.httpPost<{ totalCount: number, invoiceSummaries: InvoiceSummaryForPartnerListItem[] }>(this.mainRoute, [partnerId.toString(), "invoiceSummaries"], request).map((paginatedResult: IGetInvoiceSummaryForPartnerListResponse) => {
            return {
                totalCount: paginatedResult.totalCount,
                invoiceSummaries: paginatedResult.invoiceSummaries.map(i => {
                    return mapInvoiceSummaryForPartnerListItemDtoToDomainModel(i);
                })
            };
        }).performOperationAsync();
    }

    public getPdfAsync(invoiceSummaryId: number, partnerId: number): Promise<string> {
        return this.httpGet<string>(this.mainRoute, [partnerId.toString(), "invoiceSummaries", invoiceSummaryId.toString(), "pdf"]).map(result => {
            return result;
        }).performOperationAsync();
    }

    public getExcelAsync(invoiceSummaryId: number, partnerId: number): Promise<string> {
        return this.httpGet<string>(this.mainRoute, [partnerId.toString(), "invoiceSummaries", invoiceSummaryId.toString(), "excel"]).map(result => {
            return result;
        }).performOperationAsync();
    }

    public getDetailsAsync(invoiceSummaryId: number, partnerId: number): Promise<InvoiceSummaryDetails> {
        return this.httpGet<InvoiceSummaryDetails>(this.mainRoute, [partnerId.toString(), "invoiceSummaries", invoiceSummaryId.toString()]).map((result: IGetInvoiceSummaryDetailsResponse) => {
            return mapInvoiceSummaryDetailsDtoToDomainModel(result.details);
        }).performOperationAsync();
    }
}

export default new AdminInvoiceSummaryApiAdapter();
